<!-- //
商城-商品-详情
@auth xuyd
@date 2024-10-01
//-->
<template>
  <page-layout layout="C">
    <div class="layout-function flex-row flex-valign-center flex-halign-between">
      <div class="flex-row flex-valign-center">
        <span style="font-weight: 700">商品编辑</span>
        <el-divider direction="vertical" />
        <dict-tag class="ml10" :options="{type: 'tag'}" dictType="API_STATUS" :value="form.productStatus" />
        <dict-tag class="ml10" :options="{type: 'tag'}" dictType="ONLINE_STATUS" :value="form.onlineStatus" />
      </div>
      <div class="flex-row flex-valign-center">
        <Version v-model="form.apiVersion" class="mr10"/>
        <el-divider direction="vertical" />
        <el-button size="small" type="primary" @click="handleSave" :loading="loading">保 存</el-button>
        <el-button size="small" type="warning" @click="handleSubmit" :loading="submitLoading">提 交</el-button>
        <el-button size="small" @click="handleCancel">返 回</el-button>
      </div>
    </div>

    <div class="layout-result" style="height: 100%;margin-top: 5px;overflow-y: auto;">
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="140px"
               class="form-container flex-column flex-halign-between">
        <div class="flex-column">
          <el-form-item prop="groupId" label="接口组">
            <TreeSelect v-model="form.groupId"
                        :options="groupList"
                        :normalizer="(node) => {return {id: node.id, label: node.name,children: node.children}}"
                        :show-count="false"
                        style="width: 80%;"
                        placeholder="请选择组"/>
          </el-form-item>
          <el-form-item prop="apiName" label="接口名">
            <el-input v-model="form.apiName" clearable maxlenght="50" style="width: 80%"/>
          </el-form-item>
          <el-form-item prop="apiComment" label="接口名称（中文）">
            <el-input v-model="form.apiComment" clearable maxlenght="30" style="width: 80%"/>
          </el-form-item>
          <el-form-item prop="apiDesc" label="接口描述">
            <el-input type="textarea" placeholder="接口描述"
                      v-model="form.apiDesc"
                      maxlength="255"
                      clearable
                      style="width: 80%"
                      show-word-limit/>
          </el-form-item>
          <el-form-item prop="designUser" label="设计人">
            <el-tag type="primary">{{ form.designUserName }}（{{ form.designUser }}）</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="apiUrl" label="接口路径">
            <el-tag type="primary">/open/api/{{ form.apiName }}</el-tag>
          </el-form-item>
          <el-form-item prop="reqParamList" label="查询参数">
            <ApiQueryParams v-model="form.reqParamList" :edit-mode="true" :drag-sortable="true"
                            parameter-type="REQUEST_PARAMETER_TYPE"/>
          </el-form-item>

          <el-form-item prop="respParamList" label="返回参数">
            <ApiQueryParams v-model="form.respParamList" :edit-mode="true" :drag-sortable="true"
                            parameter-type="RESPONSE_PARAMETER_TYPE"/>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </page-layout>
</template>

<script>

import ProductApi from '@/api/mall/product.api.js';
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

const API_STATUS = {
  draft: 0, // 草稿
  waiting: 1, // 待审批
  resolve: 2, // 审批通过
  reject: 3, // 审批驳回
}
export default {
  name: 'ViewMallProductMgmtProductDetail',
  components: {TreeSelect},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'DB_TYPE', dataType: String},
    {dictType: 'API_STATUS', dataType: Number},
    {dictType: 'ONLINE_STATUS', dataType: Number},
    {dictType: 'REQUEST_PARAMETER_TYPE', dataType: String}, // 请求参数类型
    {dictType: 'RESPONSE_PARAMETER_TYPE', dataType: String}, // 返回参数类型
    {dictType: 'RESPONSE_BODY_TYPE', dataType: String}, // 返回数据体类型
  ],
  data() {
    return {
      loading: false,
      submitLoading: false,
      watcher_is_init: true, // 判断页面是否变化，首次设置区分
      watcher_is_changed: false,// 判断页面是否变化
      groupList: [],
      form: {
        id: null,
        apiName: null,
        apiComment: null,
        apiNum: null,
        apiDesc: null,
        apiStatus: null,
        apiVersion: null,
        designUser: null,
        designUserName: null,
        designTime: null,
        onlineStatus: null,
        reqParamList: [],
        respParamList: [],
      },
      rules: {
        groupId: [{required: true, message: "请选择分组", trigger: 'change'}],
        apiName: [{required: true, message: "请输入接口名", trigger: 'blur'}],
        apiComment: [{required: true, message: "请输入接口名称（中文）", trigger: 'blur'}],
      },
    }
  },
  created() {
    this.form.id = this.$route.query.id;
    this.getApiInfo();
  },
  computed: {
    editMode() {
      return !!this.form.id;
    },
  },
  watch:{
    form: {
      handler(newVal, oldVal) {
        console.log("-----form 变化前-----", this.watcher_is_init, this.watcher_is_changed)
        if(this.watcher_is_init) {
          this.watcher_is_init = false;
        } else {
          this.watcher_is_changed = true;
        }
        console.log("-----form 变化后-----", this.watcher_is_init, this.watcher_is_changed)
      },
      deep: true,
    }
  },
  methods: {
    setWatchChange(init, val) {
      this.watcher_is_init = init;
      this.watcher_is_changed = val;
    },
    getApiInfo() {
      this.form.designUser = this.$store.getters.username;
      this.form.designUserName = this.$store.getters.nickName;
      if (this.editMode) {
        ProductApi.getInfo(this.form.id).then(resp => {
          this.setWatchChange(true, false);
          this.form = resp.data;
        });
      }
    },
    handleSave() {
      // console.log("-------->", JSON.stringify(this.form.reqParamList));
      ProductApi.saveInfo(this.form).then(resp => {
        this.setWatchChange(true, false);
        this.form.id = resp.data;
        this.$modal.msgSuccess("保存成功");
        if(this.form.apiStatus === API_STATUS.resolve) {//定版更新则返回列表
          this.$router.replace({name: 'ViewApiDesignEdit', query: {id: this.form.id}});
        }
      });
    },

    handleSubmit() {
      this.$modal.confirm(`确定要提交吗？`).then(() => {
        ProductApi.submit(this.form).then(resp => {
          this.setWatchChange(true, false);
          this.form.id = resp.data;
          this.$modal.msgSuccess("提交成功");
          this.$router.back();
        });
      });
    },

    handleCancel() {
      if(this.watcher_is_changed) {
        this.$modal.confirm(`数据有变化，确定要放弃保存吗？`).then(() => {
          this.$router.back();
        })
      } else {
        this.$router.back();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.form-container {
  height: 100%;

  .full-item {
    flex: 1;
  }
}
</style>
